import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'react-final-form'

import SelectNativeInner from './SelectNativeInner'

const SelectNative = props => {
  const { name, ...remainingProps } = props

  return <Field {...remainingProps} name={name} component={SelectNativeInner} />
}

SelectNative.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
}

SelectNative.defaultProps = {}

export default SelectNative
